import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'pensiunpegawai'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const pensiunPegawaiCreate = 'Kepegawaian/PensiunPegawai/create/'
export const pensiunPegawaiList = 'Kepegawaian/PensiunPegawai/list/'
export const pensiunPegawaiDetail = 'Kepegawaian/PensiunPegawai/detail/'
export const pensiunPegawaiUpdate = 'Kepegawaian/PensiunPegawai/update/'
export const pensiunPegawaiInactive = 'Kepegawaian/PensiunPegawai/inactive/'
export const pensiunPegawaiActive = 'Kepegawaian/PensiunPegawai/active/'
export const pensiunPegawaiGetEmployee = 'Kepegawaian/PensiunPegawai/list_employee_selected/'
export const masterEmployee = 'Kepegawaian/PensiunPegawai/list_employee/'
export const masterType = 'Kepegawaian/PensiunPegawai/list_type/'
export const exportExcel = 'Kepegawaian/PensiunPegawai/exportExcel/'


//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}